/**
 * Custom Logger Utility
 * Replaces console.log for better control over log output in different environments.
 */

const isDev = import.meta.env.MODE === 'development';

export const logger = {
    info: (...args) => {
        if (isDev) {
            console.info('[Oblique INFO]', ...args);
        }
    },
    warn: (...args) => {
        if (isDev) {
            console.warn('[Oblique WARN]', ...args);
        }
    },
    error: (...args) => {
        // Errors should ideally be logged even in production (e.g., to Sentry)
        console.error('[Oblique ERROR]', ...args);
    },
    debug: (...args) => {
        if (isDev) {
            console.debug('[Oblique DEBUG]', ...args);
        }
    }
};

export default logger;
